export interface EducationHistoryData {
  schoolName: string;
  educationLevel: string;
  educationCountry: string;
  credentialReceived: string;
  startDate: string;
  endDate: string;
  fieldOfStudy?: string;
  degree?: string;
  gradeSchemeId?: string;
  gradeSchemeName?: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors?: string[];
}

export function validateEducationHistory(data: EducationHistoryData): ValidationResult {
  const errors: string[] = [];

  // Required field validation
  if (!data.schoolName || data.schoolName.trim() === '') {
    errors.push('School name is required');
  }

  if (!data.educationLevel || data.educationLevel.trim() === '') {
    errors.push('Education level is required');
  }

  if (!data.educationCountry || data.educationCountry.trim() === '') {
    errors.push('Education country is required');
  }

  if (!data.credentialReceived || data.credentialReceived.trim() === '') {
    errors.push('Credential received is required');
  }

  if (!data.startDate || data.startDate.trim() === '') {
    errors.push('Education start date is required');
  }

  if (!data.endDate || data.endDate.trim() === '') {
    errors.push('Education end date is required');
  }

  // Business rule: start date must be before end date
  if (data.startDate && data.endDate) {
    const start = new Date(data.startDate);
    const end = new Date(data.endDate);
    if (start >= end) {
      errors.push('Education start date must be before end date');
    }
  }

  if (errors.length > 0) {
    return { isValid: false, errors };
  }

  return { isValid: true };
}
